module.exports = __webpack_public_path__ + "2021-05-20T043626520Z/img/cake.a77eccbe.png";